import React from 'react'

import { ITeamCategoryFiltersProps } from '../_types/team-categories.types'

import ATeamCategoryNavigation from './a-team-category-navigation'
import ATeamSearch from './a-team-category-search'

const ATeamCategoryFilters: React.FC<ITeamCategoryFiltersProps> = ({
	teamCategory,
	teamCategories,
	onSearchChange,
	searchQuery
}) => {
	const handleSearchChange = (searchValue: string) => {
		onSearchChange(searchValue)
	}

	return (
		<div className='flex flex-col gap-4 md:flex-row justify-between mb-6 md:mb-10'>
			<ATeamCategoryNavigation teamCategories={teamCategories} teamCategory={teamCategory} />
			<ATeamSearch searchQuery={searchQuery} onSearchChange={handleSearchChange} />
		</div>
	)
}

export default ATeamCategoryFilters
